import type { StoryElement } from '../types';

export type BetaSearchSort = 'recency' | 'specificity' | null;

export const BETA_SEARCH_SORT_OPTIONS = [
  { value: null, label: 'Default' },
  { value: 'recency', label: 'Recent first' },
  { value: 'specificity', label: 'More specific first' },
] as const;

/**
 * Millisecond timestamp of a story's publication (or creation date fallback).
 * Returns 0 if missing or invalid.
 */
export function getStoryTimestamp(story: StoryElement): number {
  const raw = story.published_at || story.created_at;
  if (!raw) return 0;
  const parsed = Date.parse(raw);
  return Number.isNaN(parsed) ? 0 : parsed;
}
